export default __webpack_public_path__ + "static/media/GDSC Small.05fd097a.svg";